// eslint-disable-next-line import/prefer-default-export
export function convertFractionToPercent(fractionNumber, options = { precision: 2 }) {
  return ((fractionNumber * 100) || 0).toFixed(options.precision);
}

export const roundCurrency = number => (number * 100) / 100;
